import { render, staticRenderFns } from "./YakitonTeruTeru.vue?vue&type=template&id=73a90067&scoped=true"
import script from "./YakitonTeruTeru.vue?vue&type=script&lang=js"
export * from "./YakitonTeruTeru.vue?vue&type=script&lang=js"
import style0 from "./YakitonTeruTeru.vue?vue&type=style&index=0&id=73a90067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a90067",
  null
  
)

export default component.exports